// extracted by mini-css-extract-plugin
module.exports = {"followersHolder":"Followers_followersHolder__2JlQd","followers":"Followers_followers__34JIm"};